<template>
  <div v-if="video" class="add-filess-wrapper">
    <div class="add-filess">
      <div @click="closeVideo" class="close">&#215;</div>
      <p class="center">Отказ от страхования? Ответы на вопросы в видеоролике</p>
      <div id="player" class="video">
        <!-- <youtube-iframe
          ref="iframeTmp"
          :video-id="'EnqVqYibDaw'"
          :player-width="'100%'"
          :playerHeight="'100%%'"
          :playerParameters="{disablekb:1, modestbranding:1, rel:0, iv_load_policy:3, showinfo:0}"
          @state-change="stateChange"
        ></youtube-iframe> -->
        <div style="position: relative; padding-top: 56.25%; width: 100%">
          <iframe src="https://kinescope.io/embed/wYXrzsYUZuRG1nDjF9GSXE" allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write;" frameborder="0" allowfullscreen="" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"></iframe>
        </div>
       <!-- <iframe width="100%" src="https://www.youtube.com/embed/EZ1ajpyixL8?si=6ZuLfQJr1MP4zme4&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> -->
      </div>
      <p class="small center">Возможность подтвердить желание расторгнуть договор активируется после просмотра видео</p>
      <a style="display: block;" class="btn btn-outline-danger" @click.prevent="$router.push({name: 'termination', params: { id: contract_id }})" :href="'/profile/termination/' + contract_id">Расторгнуть</a>
    </div>
  </div>
  <div v-if="file_load_block" class="add-filess-wrapper">
    <div class="add-filess">
      <div @click="closeAddFiles" class="close">&#215;</div>
      <p class="add-files-title">Загрузка файлов к заявлению</p>
      <div class="files">
        <label v-if="files.length > 0">
          Добавленные файлы
          <div v-for="(file, index) of files" :key="index">
            <div>{{ file.file_name }}<i @click="delFiles(index)" style="color:red" class="icon-close_16"></i></div>
          </div>
        </label>
        <button type="button"><label for="file">Добавить файл</label></button>
        <input  id="file" type="file" name="files" :multiple="true" @change="loadFiles" style="display: none;">
      </div>
      <div class="action-errors">
        <div class="send">
          <div v-if="sending">Данные отправляются</div>
          <button @click="sendFiles" :class="{disabled: sending}" type="button" class="send-files" :disabled="sending">Отправить</button>
        </div>
        <div v-if="errors.length > 0" class="errors">
          <div v-for="(error, key) in errors" :key="key" class="error">
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="accardion-content accardion-content-active">
    <div class="policy-accardion-items-header">
      <div class="policy-accardion-items-title" style="width: 19%;">Наименование</div>
      <div class="policy-accardion-items-title" style="width: 19%;">Дата подачи</div>
      <div class="policy-accardion-items-title" style="width: 19%;">Статус</div>
      <div v-if="isDesk" class="policy-accardion-items-title" style="width: 39%;">Описание статуса</div>
      <div class="policy-accardion-items-title" style="width: 4%;"></div>
    </div>
    <div v-for="(st, key) in statements" :key="key" class="policy-accardion-items">
      <div class="policy-accardion-items-text" style="width: 19%;">{{ statements_types_data[st.TYPE] }}</div>
      <div class="policy-accardion-items-text" style="width: 19%;">{{ st.DOC_DATE }}</div>
      <div class="policy-accardion-items-text" style="width: 19%;">{{ statements_status_data[st.STATUS] }}</div>
      <div v-if="isDesk" class="policy-accardion-items-text" style="width: 39%;">{{ statements_status_desc[st.STATUS] }}</div>
      <div v-if="!b2bframe" class="policy-accardion-items-text" style="width: 4%;"><span @click="addFiles(st.TYPE)" title="Добавить файлы" class="add-files"><img
        src="../assets/save-file.svg" alt="upload-file"></span></div>
    </div>
    <hr>
    <div v-if="termination_need" class="buttons">
      <a @click.prevent="question" class="btn btn-outline-danger" :href="'/profile/termination/' + contract_id">Подать заявление о расторжении</a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {url} from "@/profile/composables/url";

export default {
  name: "StatementsComponent",
  props: ['statements', 'contract_id', 'status', 'type', 'status_doc'],
  data: () => {
    return {
      files: [],
      type_statement_files: '',
      file_load_block: false,
      statements_status_data: {
        '0': 'Отправлен',
        '100': 'Зарегистрирован',
        '200': 'На рассмотрении',
        '300': 'На рассмотрении',
        '400': 'Требуется уточнение',
        '500': 'Принято решение о выплате',
        '600': 'Выплата произведена',
        '700': 'Рассмотрено. Отправлен ответ',
        '800': 'Запрошены дополнительные документы',
        '810': 'Направлен запрос в ФНС',
        '820': 'Запрошены оригиналы документов',
        '900': 'Платеж вернулся в Страховую компанию.',
        '999': 'Исполнен',
      },
      statements_status_desc: {
        '0': '',
        '100': 'Ваше обращение получено и зарегистрировано Страховой Компанией ООО «МАКС-Жизнь».',
        '200': 'Ваше обращение передано в ответственное подразделение, находится на рассмотрении.',
        '300': 'Ваше обращение передано в ответственное подразделение, находится на рассмотрении.',
        '400': 'У Страховой Компании ООО "МАКС-Жизнь" возникли вопросы по Вашим документам.Пожалуйста, свяжитесь с нами по тел. 88003339013, 84993508689',
        '500': 'Выплата по договору страхования будет произведена на указанные в заявлении реквизиты счета.',
        '600': 'По Вашему обращению выплата произведена.',
        '700': 'По Вашему обращению направлен ответ. Подробности по отправленному ответу Вы можете получить, связавшись c нами по тел. 88003339013, 84993508689',
        '800': 'По Вашему обращению направлен запрос недостающих документов. Подробности по отправленному запросу Вы можете получить, связавшись с нами по тел. 88003339013, 84993508689',
        '810': 'По вашему обращению направлен запрос в налоговую службу для получения информации о получении/ неполучении социального налогового вычета по договору страхования',
        '820': 'Документы по вашему обращению рассмотрены Страховой компанией. Для  получения выплаты необходимо предоставить оригинал комплекта в ООО «МАКС-Жизнь»',
        '900': 'Платеж вернулся в Страховую компанию. Пожалуйста, свяжитесь с нами для уточнения реквизитов.',
        '999': 'Обращение рассмотрено и исполнено. ООО "МАКС-Жизнь"',
      },
      statements_types_data: {
        in_letter: 'Входящее письмо',
        in_letter_control: 'Входящее письмо, требующее контроля',
        contract: 'Договор',
        additional_agreement: 'Дополнительное соглашение',
        complaint: 'Жалоба',
        request: 'Запрос',
        supervisory_request: 'Запрос надзорных органов',
        application: 'Заявление',
        survivorship_application: 'Заявление на дожитие',
        modification_application: 'Заявление на изменение',
        termination: 'Заявление на расторжение',
        insurance_claim: 'Заявление о страховой выплате',
        lawsuit: 'Исковое заявление',
        claim: 'Претензия',
        court_summons: 'Судебная повестка',
        court_ruling: 'Судебное определение',
        tax_certificate: 'Заявление на сведения/справку для налогового вычета'
      },
      file_valid_types: [
        "doc",
        "docx",
        "rtf",
        "txt",
        "bmp",
        "jpg",
        "jpeg",
        "gif",
        "png",
        "zip",
        "rar",
        "xls",
        "xlsx",
        "pdf",
      ],
      errors: [],
      sending: false,
      video: false,
      viewed: false,
    }},
  methods: {
    stateChange(event) {
      if (event.data == 0) {
        this.viewed = true;
      }
    },
    question() {
      if (this.type == 'cred') {
        this.video = true;
        // let $this = this;
        // setTimeout(function(){
        //   // let iframeEl = document.getElementsByTagName('iframe')[0];
        //   let iframeEl = $this.$refs.iframeTmp.getIframe();
        //   iframeEl.style.position = 'absolute';
        //   iframeEl.style.top = '0';
        //   iframeEl.style.left = '0';
        //   // iframeEl.setAttribute('style', 'position: absolute;left: 0;top: 0;');
        // }, 100);
        return;
      }
      // let result = confirm('Вы точно хотите расторгнуть договор?');
      // if (!result) {
      //   return
      // } else {
        //переходим по ссылке
      //   this.$router.push({ name: 'termination', params: { id: this.contract_id }});
      // }
    },
    closeVideo: function () {
      this.video = false;
      this.viewed = false;
    },
    addFiles: function (type){
      this.type_statement_files = type;
      this.file_load_block = true;
    },
    closeAddFiles: function () {
      this.file_load_block = false;
      this.files = [];
      this.sending = false;
      this.type_statement_files = '';
    },
    delFiles(i) {
      this.files.splice(i, 1);
      // console.log(this.files)
    },
    loadFiles(event) {
      for (let i=0; i<event.target.files.length; i++) {
        let type_arr = event.target.files[i].type.split('/');
        if (!this.file_valid_types.includes(type_arr[1])){
          this.errors = [];
          this.errors.push('Недопустимый фомат файла');
          return
        } else {
          this.errors = [];
        }
        this.getBase64(event.target.files[i]).then(
          data => this.files.push({
            file_name: event.target.files[i].name,
            mime: event.target.files[i].type,
            file_data: data,
          })
        );
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    sendFiles() {
      if (this.files.length == 0) {
        this.errors.push('Добавьте файлы');
        return
      }
      this.sending = true;
      let params = {
        command: "add_files_to_statement",
        contract_id: this.contract_id,
        files: this.files,
        type: this.type_statement_files,
        token: this.$myApp.token.get(),
      };
      let $this = this;
      axios
        .post(url, {
          params: params,
        })
        .then(function (response) {
          let data = response.data;
          if (data.state == "ERR") {
            $this.errors = [];
            $this.errors.push(data.msg_text);
            // console.log(data);
          }
          if (data.state == "OK") {
            alert('Документы успешно отправлены');
            $this.type_statement_files = '';
            $this.files = [];
            $this.file_load_block = false;
            $this.sending = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  computed: {
    termination_need: function() {
        return false;
      // let arr = this.statements;
      // let term_statuses = ['3', '6', '14', '4'];
      // // console.log(term_statuses.includes(this.status_doc));
      // if (term_statuses.includes(this.status_doc)){
      //   return false;
      // }
      // if (this.type != 'cred') {
      //   return false;
      // }
      // if (arr == undefined) {
      //   return true;
      // }
      // let ret = arr.filter(function(item) {
      //   return item.TYPE == 'termination';
      // });
      // if (ret.length > 0) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
    isDesk: function() {
      // if (this.type == 'cred') {
      //   return false;
      // }
      let arr = this.statements;
      let desk = this.statements_status_desc;
      if (arr === undefined) {
        return false;
      }
      let ret = arr.filter(function(item) {

          if (item.STATUS == '500') {
              if (item.DOC_PAYMENT) {
                  return desk[item.STATUS] = 'Выплата по договору страхования будет произведена ' + item.DOC_PAYMENT + ' на указанные в заявлении реквизиты счета';
              }
          }

        if (item.STATUS == '100') {
          if (item.REGISTRATION_DATE) {
            return desk[item.STATUS] = 'Ваше обращение получено и зарегистрировано Страховой Компанией ООО «МАКС-Жизнь». Номер входящего обращения ' + item.REGISTRATION_NUMBER + ' от ' + item.REGISTRATION_DATE;
          }
        }
        return desk[item.STATUS] != '';
      });
      if (ret.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    b2bframe() {
      if (this.$route.params.token) {
        return true
      } else {
        return false
      }
    }
  },
}
</script>

<style scoped>
.add-filess {
  position: fixed;
  top: 10%;
  width: 60%;
  background-color: white;
  -webkit-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  -moz-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  left: 20%;
  z-index: 10000;
  padding: 30px;
  cursor: auto;
  min-height: 60vh;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
}
.add-files>img{
  width: 15px;
  margin-top: 10px;
}
.add-filess-wrapper{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.7);
  z-index: 100;
}
.add-files-title{
  text-align: center;
}
.action-errors{
  position: absolute;
  bottom: 30px;
  display: flex;
  justify-content: space-between;
  width: calc(100% - 60px);
}
.send-files{
  padding: 10px;
  background: #0062cc;
  color: #FFFFFF;
  border: 2px solid #005cbf;
  outline: #0075D4;
  cursor: pointer;
  font: 700 20px SourceSansPro, sans-serif;
  border-radius: .3rem;
}
.send-files:hover{
  background: #004389;
}
.disabled {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
}
.small  {
  font-size: 10pt;
}
.vue-youtube-iframe{
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
}
iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>